module.exports = __webpack_public_path__ + "static/media/confirmation-pole.d80e1bb9.svg";